<template>
    <v-container>
        <div>
            <div style="background-color: rgb(230, 233, 242);">
                <v-img :src="require('../assets/rcp4.png')" max-width="100%" contain>
                    <v-row>
                        <v-col cols="12" md="6" lg="6">
                            <p style="font-size: 2rem; color: rgb(0, 30, 67);padding-left: 20px; margin-top: 20px;">
                                <b>UN Information Laboratory on Crime and Corruption for Latin America and the Caribbean (UN iLabCC)</b>
                            </p>                            
                        </v-col>
                    </v-row> 
                </v-img>
            </div>
            <!-- Descripción -->
            <v-spacer></v-spacer>
            <br>
            <v-card-text>
                <div>
                    <h2>About UN iLabCC</h2>
                    <p>
                      Developed and led by the United Nations Office on Drugs and Crime (UNODC), UN iLabCC is implemented jointly by the United Nations System within the framework of the 
                      <a href="https://www.rcplac.org/" target="_blank">Regional Collaborative Platform in Latin America and the Caribbean</a> through its 
                      <a href="https://www.rcplac.org/en/ibcs-and-working-groups/ibc-on-governance-for-peace-justice-and-strong-institutions" target="_blank">Issue-based Coalition on Governance for Peace, Justice and Strong Institutions</a> 
                      (IBC-GPJSI). As the regional knowledge and policy support platform of the IBC-GPJSI, it supports the dissemination and implementation of UN common positions, common approaches and integrated policy responses to corruption, organized crime and other challenges related to SDG 16 and the 2030 Agenda. 
                    </p>
                    <p>
                      UN iLabCC brings together specialized expertise, international standards, analytical tools, learning resources, good practices and mappings of United Nations programmes and capacities across priority thematic areas, supporting coherent, evidence-based and integrated UN engagement throughout the region. 
                    </p>
                    <br>
                    <h4>UN iLabCC offers:</h4>
                    <p style="padding-left: 1rem;">
                        <ul>
                            <li>Integrated policy guidance and knowledge resources on corruption, organized crime, drugs, violence, crime prevention, criminal justice, governance and related SDG 16 priorities. </li>
                            <li>A curated repository of international standards, United Nations tools, methodologies, analytical products and good practices. </li>
                            <li>Mappings of United Nations programmes, initiatives, expertise and capacities across thematic areas. </li>
                            <li>Support for the dissemination and implementation of UN common positions, common approaches and integrated policy responses. </li>
                            <li>E-learning courses, webinars and other capacity-development opportunities. </li>
                        </ul>
                    </p>
                    <p>
                        The platform is intended primarily for Resident Coordinators, Resident Coordinator Offices and United Nations Country Teams in Latin America and the Caribbean, as well as members of the IBC-GPJSI and other United Nations personnel participating in the Regional Collaborative Platform for Latin America and the Caribbean. 
                    </p>
                </div>
            </v-card-text>
            <v-spacer></v-spacer>
        </div>
    </v-container>
</template>
<script>
export default {
    data() {
        return {
            card: {
                id: 0,
                title: '',
                subtitle: '',
                description: '',
                additionalInfo: '',
                images: [],
                chip: [],
            },
            showPdf: false,
            cards: [
                {
                    id: 1,
                    title: '',
                    subtitle: '',
                    description: '<p><b>LABCC</b><br></p>'+
'<p>The United Nations Laboratory on Crime and Corruption for Latin America and the Caribbean provides UN Resident Coordinators and UN Country Teams with access to tools, knowledge products and e-learning on organized crime, drugs, transparency, governance, crime prevention and criminal justice, and violence, amongst other topics related to the Sustainable Development Goal (SDG) 16 and other related goals. More information </p><p></p>'+
'<p><b>With a click on more information the following text will have to appear:</b><br></p>'+
'<p>It is a project developed and led by the United Nations Office on Drugs and Crime and implemented jointly by the United Nations System in the framework of the <a href="https://www.rcplac.org/" target="_blank">Regional Collaborative Platform in Latin America and the Caribbean</a> through <a href="https://www.rcplac.org/en/ibcs-and-working-groups/ibc-on-governance-for-peace-justice-and-strong-institutions" target="_blank">its Issue-based Coalition on Governance for Peace, Justice and Strong Institutions</a>.</p>'+
'<p>LabCC aims to provide key resources for the development of evidence-based legal, policy and institutional frameworks to effectively prevent and combat transnational organized crime and corruption, amongst other topics related to SDG 16, with the aim of strengthening the capacities of UNCTs and ultimately Member States in the region.</p>'+
'<p>The target audience of LabCC is made up of Resident Coordinators and members of the United Nations Country Teams in Latin America and the Caribbean (LAC), members of the IBC on SDG 16 in LAC, and other staff members from agencies, programmes and funds that make up the United Nations <a href="https://www.rcplac.org/" target="_blank">Regional Collaboration Platform for LAC</a>.</p>'+
'<p>The following UN agencies, programmes and funds are participating in this project: UNODC, UNOPS, UNDP, WFP (has not participate in the IBC in 2023), ECLAC (has not participated in the IBC in 2023), ILO, IOM, OHCHR (has not participated in the IBC in 2023), UNFPA, UNHCR, UNICEF, UN-Women, UNAIDS (has not participated in the IBC in 2023), UNDCO, UNESCO, DPPA.</p>'+
'<p>[ NOTE: We need to get key tools and resources from ECLAC, OHCHR, UNAIDS and WHO and insist with regional directors on the responsibilities of their focal points]</p>'+
'<p></p>',
                    additionalInfo: 'Additional Info for Card 1',
                    images: ['category1-1.jpg', 'category1-2.jpg'],                    
                    chip: ['8:00 AM', '10:00 AM', '2:00 PM', '4:00 PM'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/0.%20UNODC%20Global?csf=1&web=1&e=8Sy2kH',
                },
                {
                    id: 2,
                    title: 'Centro de Excelencia INEGI UNODC',
                    subtitle: 'INEGI',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 2',
                    images: ['logo.png', 'logo2.png'],                    
                    chip: ['7:00 AM', '9:00 AM', '11:00 AM'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/Centro%20de%20Excelencia%20INEGI%20UNODC?csf=1&web=1&e=dLIVXd',
                },
            ],
        };  
    },
    methods: {
        async listar() {
            try {
                const response = await axios.get('api/Publication/Listar');
                this.datos = response.data;

                // Ahora que tienes los datos, puedes mapearlos al formato que esperas para las tarjetas (cards)
                this.cards = this.datos.map(category => {
                    return {
                        id: category.oid,
                        title: category.title,
                        subtitle: category.subtitle,
                        description: category.description,
                        images: ['fondo2.jpg'],   // Asegúrate de manejar el caso donde images es null o undefined
                    };
                });
            } catch (error) {
                console.error(error);
            }
        },
        getImageSrc(filename) {
            return require(`../assets/${filename}`);
        },
        openPdf() {
            this.showPdf = true;
        },
    },
    created() {
        const cardId = parseInt(this.$route.params.id);
        this.card = this.cards.find(card => card.id === cardId);
    },
};
</script>
<style>
    p {
        font-family: 'Heebo', sans-serif;
        font-size: 17px;        
        line-height: 1.6em;
    }
    h1 {
        font-family: 'Heebo', sans-serif;
    }
    h2 {
        font-family: 'Heebo', sans-serif;
    }
    h3 {
        font-family: 'Heebo', sans-serif;
    }
    .p1 {
        font-family: 'Heebo', sans-serif;
        font-size: 14px;        
        line-height: 1.6em;
    }
</style>